<template>
  <svg
    @click="triggerClear"
    class="searchPage__clear"
    width="29"
    height="29"
    viewbox="0 0 29 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1.92969"
      y="0.374512"
      width="37.0712"
      height="2"
      transform="rotate(45.1527 1.92969 0.374512)"
      fill="#212121"
    />
    <rect
      x="0.398438"
      y="26.6011"
      width="37.3429"
      height="2"
      transform="rotate(-45.2109 0.398438 26.6011)"
      fill="#212121"
    />
  </svg>
</template>

<script>
export default {
  name: 'CloseSearch',

  methods: {
    triggerClear() {
      this.$emit('clearSearch');
    },
  },
};
</script>
